import { motion } from "framer-motion";
import { EASE } from "@/lib/lenis";
import { GlowField } from "@/components/site/GlowField";
import { MaskedLines } from "@/components/motion/Reveal";

export const PageHero = ({ eyebrow, lines, copy, testId, children }) => (
  <section className="relative isolate overflow-hidden pb-16 pt-36 sm:pb-24 sm:pt-44" data-testid={testId}>
    <GlowField />
    <div className="hero-lines pointer-events-none absolute inset-0 -z-10" aria-hidden="true" />
    <div className="container-x">
      <motion.p
        className="eyebrow"
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: EASE }}
      >
        {eyebrow}
      </motion.p>
      <MaskedLines
        as="h1"
        lines={lines}
        delay={0.1}
        testId={`${testId}-title`}
        className="mt-6 max-w-5xl text-[2.6rem] font-semibold leading-[1.02] tracking-[-0.04em] sm:text-6xl lg:text-7xl"
        lineClassName="text-sheen"
      />
      {copy && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: EASE, delay: 0.5 }}
          className="mt-8 max-w-2xl text-base leading-relaxed text-[#A1A1AA] sm:text-lg"
        >
          {copy}
        </motion.p>
      )}
      {children}
    </div>
  </section>
);
